module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../node_modules/happypack/loader.js?id=jsx!./SearchView.js"));
	}, "ToolsSearchView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=ToolsSearchView!./src/pages/Learn/ToolsSearch/SearchView.js
// module id = 1236
// module chunks = 438